// Shared constants for the Operations Planner. Categories mirror
// OperationsPlanItem::CATEGORIES on the backend; statuses mirror the
// STATUS_* constants there.

export const PLAN_CATEGORIES = [
  'Production',
  'Animal Health & Welfare',
  'Crop & Plant Health',
  'Land, Soil & Water',
  'Biosecurity',
  'Machinery & Equipment',
  'Infrastructure',
  'Workforce',
  'Safety',
  'Compliance',
  'Environment',
  'Harvest, Quality & Logistics',
];

export const PLAN_ITEM_STATUSES = [
  { value: 'not_yet_due', label: 'Not yet due', color: 'default' },
  { value: 'awaiting_confirmation', label: 'Awaiting confirmation', color: 'orange' },
  { value: 'in_progress', label: 'In progress', color: 'blue' },
  { value: 'completed', label: 'Completed', color: '#067647' },
];

export const PLAN_ITEM_STATUS_MAP = PLAN_ITEM_STATUSES.reduce((map, status) => {
  map[status.value] = status;
  return map;
}, {});
